'use client';

import { FloatingOverlay } from '@floating-ui/react';
import { forwardRef, useContext } from 'react';

import { css, cx, splitResponsiveVariant } from '@/styled-system/css';

import { ModalRootContext } from './context/modal-root.context';
import { modalBackdropRecipe } from './styles/modal-backdrop.styles';
import type { ModalBackdropPropsInterface } from './types/modal-backdrop.types';

/**
 * @since 10.0.0
 */
export const ModalBackdrop = forwardRef<HTMLDivElement, ModalBackdropPropsInterface>(
  (props: ModalBackdropPropsInterface, forwardedRef) => {
    const { modal, scrollDocument, size } = useContext(ModalRootContext);
    const { children, className, css: cssProp, lockScroll = true, ...rest } = props;

    const responsiveSize = splitResponsiveVariant('size', size);
    const styles = css(
      modalBackdropRecipe.raw({
        open: modal.transitionStatus === 'open',
        scrollDocument,
        ...responsiveSize,
      }),
      cssProp,
    );

    return (
      <FloatingOverlay
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Modal.Backdrop"
        className={cx('c11n', 'c11n_modal__backdrop', styles, className)}
        lockScroll={lockScroll}
        {...rest}
      >
        {children}
      </FloatingOverlay>
    );
  },
);

ModalBackdrop.displayName = 'Modal.Backdrop';
